export default __webpack_public_path__ + "static/media/friendly03.ade27bc6.png";